module.exports = __webpack_public_path__ + "img/mechas-effect.8c7fa405.png";